import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Row, Col, FormGroup, Label, Input, Button, Alert } from 'reactstrap';
import { ToastNotification } from '../Lessons/CourseReport/CourseReportComponents';
import {  addData, updateData } from '../../lib/studentprogresstask';
import { TaskTopic911Select, TaskTopic12Select } from '../Common/FormSelects';
import { getStudentClass } from '../../lib/classdetailview';

const getCurrentDateInput = () => {
    const today = new Date();
    return today.toISOString().split('T')[0];
};

const StudentTaskModal = ({ isOpen, toggle, studentId, type, taskToEdit, onSave }) => {
    const [taskTopic, setTaskTopic] = useState('');
    const [assignmentText, setAssignmentText] = useState('');
    const [assignedDate, setAssignedDate] = useState(getCurrentDateInput());
    const [dueDate, setDueDate] = useState(getCurrentDateInput());
    const [studentClass, setStudentClass] = useState();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [toastMessage, setToastMessage] = useState('');
    const [showToast, setShowToast] = useState(false);

    const showToastMessage = (message) => {
        setToastMessage(message);
        setShowToast(true);
        setTimeout(() => setShowToast(false), 3000);
    }

    const isEdit = !!taskToEdit;

    useEffect(() => {
        if (isOpen) {
            if (isEdit) {
                setAssignmentText(taskToEdit.taskname || '');
                setAssignedDate(taskToEdit.taskdate || getCurrentDateInput());
                setDueDate(taskToEdit.taskenddate || getCurrentDateInput());
                setTaskTopic(taskToEdit.subject || '');
            } else {
                setAssignmentText('');
                setAssignedDate(getCurrentDateInput());
                setDueDate(getCurrentDateInput());
                setTaskTopic('');
            }
            getStudentClassData();
        }
    }, [isOpen, taskToEdit]);

    const getStudentClassData = async () => {
        try {
            const classInfo = await getStudentClass(studentId);
            if (classInfo && classInfo.length > 0) {
                setStudentClass(classInfo[0].grade);
            }
        } catch (error) {
            console.error('Failed to fetch student class:', error);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        const payload = {
            studentId,
            taskname: assignmentText,
            taskdate: assignedDate,
            taskenddate: dueDate,
            isFinish: taskToEdit?.isFinish || false,
            progresstype: type,
            subject: taskTopic
        };

        try {
            if (isEdit) {
                await updateData(taskToEdit.id, payload);
            } else {
                await addData(payload);
            }
            onSave();
            showToastMessage(isEdit ? 'Task updated successfully!' : 'Task added successfully!');
            setTimeout(() => toggle(), 2000);
        } catch (error) {
            console.error('Failed to save task:', error);
            setError('An error occurred while saving the task.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle} size="lg">
            <ModalHeader toggle={toggle}>
                {isEdit ? 'Update Task' : 'Add New Task'}
            </ModalHeader>
            <ToastNotification show={showToast} message={toastMessage} onClose={() => setShowToast(false)} />
            <ModalBody>
                {error && (
                    <Alert color="danger">
                        <strong>Error:</strong> {error}
                    </Alert>
                )}
                <form onSubmit={handleSubmit} id="student-task-form">
                    <Row>
                        <Col lg="6">
                            <FormGroup>
                                <Label className="form-control-label">Topic</Label>
                                {studentClass > 11 ? (
                                    <TaskTopic12Select value={taskTopic} setValue={setTaskTopic} />
                                ) : (
                                    <TaskTopic911Select value={taskTopic} setValue={setTaskTopic} />
                                )}
                            </FormGroup>
                        </Col>
                        <Col lg="6">
                            <FormGroup>
                                <Label className="form-control-label">Task</Label>
                                <Input
                                    type="text"
                                    value={assignmentText}
                                    onChange={(e) => setAssignmentText(e.target.value)}
                                    placeholder="Enter task description"
                                    required
                                    disabled={loading}
                                />
                            </FormGroup>
                        </Col>
                    </Row>

                    <Row>
                        <Col lg="6">
                            <FormGroup>
                                <Label className="form-control-label">Assignment Date</Label>
                                <Input type="date" value={assignedDate} onChange={(e) => setAssignedDate(e.target.value)} disabled={loading} />
                            </FormGroup>
                        </Col>
                        <Col lg="6">
                            <FormGroup>
                                <Label className="form-control-label">Due Date</Label>
                                <Input type="date" value={dueDate} onChange={(e) => setDueDate(e.target.value)} disabled={loading} />
                            </FormGroup>
                        </Col>
                    </Row>
                </form>
            </ModalBody>
            <ModalFooter>
                <Button color="primary" type="submit" form="student-task-form" disabled={loading}>
                    {loading ? 'Saving...' : isEdit ? 'Update Task' : 'Add Task'}
                </Button>
                <Button color="secondary" onClick={toggle} disabled={loading}>
                    Cancel
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default StudentTaskModal;
